import React from 'react';
import subtractTopLeft from '../../../assets/error-page/subtract-top-left.svg';
import subtractBottomLeft from '../../../assets/error-page/subtract-bottom-left.svg';
import subtractRightLarge from '../../../assets/error-page/subtract-right-large.svg';
import subtractRightSmall from '../../../assets/error-page/subtract-right-small.svg';

/**
 * Decorative background shapes for error pages.
 * Hidden on mobile (< 768px) for cleaner design.
 */
export const ErrorPageBackground: React.FC = () => {
  return (
    <div className="absolute left-[-48.53px] top-[-84.8px] hidden md:block">
      {/* Top left chevron */}
      <div className="absolute left-[-48.53px] top-[71.25px] h-[778.071px] w-[543.374px] rotate-180 scale-y-[-1] opacity-70">
        <img src={subtractTopLeft} alt="" className="block h-full w-full" aria-hidden="true" />
      </div>

      {/* Bottom left chevron */}
      <div className="absolute left-[-48.53px] top-[792.88px] h-[346.66px] w-[242.094px] scale-y-[-1] opacity-70">
        <img src={subtractBottomLeft} alt="" className="block h-full w-full" aria-hidden="true" />
      </div>

      {/* Right large chevron */}
      <div className="absolute left-[540px] top-[101.48px] h-[1415.318px] w-[988px] opacity-70">
        <img src={subtractRightLarge} alt="" className="block h-full w-full" aria-hidden="true" />
      </div>

      {/* Right small chevron */}
      <div className="absolute left-[1305px] top-[136px] h-[166.709px] w-[117px] opacity-70">
        <img src={subtractRightSmall} alt="" className="block h-full w-full" aria-hidden="true" />
      </div>
    </div>
  );
};
